<template>
  <div class="text-zt-danger" v-if="shown">
    <span v-for="(message, i) in messages" :key="i" class="text-zt-xs">
      {{ message }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'ValidationMessage',
  props: {
    rules: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      messages: [],
      shown: false
    }
  },
  watch: {
    rules: {
      handler(rules) {
        if (rules) {
          const { invalid, fieldName, failedRules} = rules
          this.messages = this.getMessageError(fieldName, failedRules)
          this.shown = invalid === true
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getMessageError(field, rules) {
      return Object.keys(rules).map(rule => this.$t(`message.selfService.fieldsError.${field}.${rule}`))
    }
  }
}
</script>

<style scoped>

</style>